// Copyright (c) 2017 Deere & Company

import auditPreparation from './audit-preparation';
import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import isAuditLoaded from './is-audit-loaded';
import isSystemSelectedClaimsModalVisible from './system-selected-claims-modal-visibility';

export const getCombinedReducers = () => combineReducers({
    auditPreparation,
    busyCounter,
    isAuditLoaded,
    isSystemSelectedClaimsModalVisible
});



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/reducers/index.js